import { Grid } from '@mui/material'

import TimePicker from './TimePicker'

const GridTimePicker = ({ label, field, value, onChange = () => {} }) => (
  <Grid size={{ xs: 12, md: 'grow' }}>
    <center>
      <TimePicker
        label={label}
        value={value}
        onChange={i => onChange(field, i)}
      />
    </center>
  </Grid>
)

export default GridTimePicker
